/**
 *   Configuration for sending an overridden locale for dark read
 *   requests from endpoints with localeOverride = true set in the DarkReads annotation
 */ export var PERF_DARK_READ_TESTING_OVERRIDE_LOCALE_HEADER = 'PERF_DARK_READ_TESTING_OVERRIDE_LOCALE_HEADER';
